<form [formGroup]="adicionaLanceFormGroup">

  <div mat-dialog-content>

    <mat-horizontal-stepper [linear]="true" #adicionaLanceStepper>
      <mat-step *ngIf="!usuarioEstaLogado">
        <app-registro-cliente *ngIf="!usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_conhecer' | transloco}}"
          (registroFinalizado)="registroFinalizado($event)">
        </app-registro-cliente>

        <app-acesso-cliente *ngIf="usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_acesso' | transloco}}"
          (acessoFinalizado)="acessoFinalizado($event)">
        </app-acesso-cliente>

      </mat-step>

      <mat-step [stepControl]="adicionaLanceFormGroup">

        <h1>{{data?.nomeProduto}}</h1>

        <div class="row itens-align-center pt-4 pb-0 ml-2">
          <div class="col-xl-2">
            <p><i class="fa-solid fa-handshake text-inversu fa-xl pr-2"></i>{{ data?.valor_pretendido > 0 ?
              (data?.valor_pretendido | currency: "BRL":'symbol') : ('nao_especificado' | transloco)}}</p>
          </div>
          <div class="col-xl-2">
            <p><i class="fa-solid fa-trophy text-inversu fa-xl pr-2"></i>{{ data?.melhor_lance ? (data?.melhor_lance |
              currency: "BRL":'symbol') : ('nenhum_lance_simples' | transloco)}}</p>
          </div>
          <div class="col-xl-2">
            <p><i class="fa-solid fa-boxes-stacked text-inversu fa-xl pr-2"></i>{{data?.quantidade ? data?.quantidade :
              0}}</p>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-xl-6 align-items-center pt-4">
            <app-campo-dinheiro [formulario]="adicionaLanceFormGroup" nomeControle="valor_lance"
              descricao="Valor do meu lance" classe="horizontal-100"></app-campo-dinheiro>
          </div>
          <div class="col-xl-6 align-items-center pt-sm-3">
            <h3>Você receberá <strong class="text-inversu">{{ adicionaLanceFormGroup.controls['valor_lance']?.value * (1
                - taxa) | currency: "BRL":'symbol'}}</strong> por essa venda, caso seja o vencedor da negociação.</h3>
          </div>
        </div>

        <div class="row align-items-center pb-4">
          <div class="col-xl-6">
            <mat-checkbox class="ml-1" formControlName="retirada_local" (change)="teste()">
              {{'permite_retirada_endereco' | transloco}}.
            </mat-checkbox>
          </div>
        </div>

        <div class="alert alert-primary pt-4 pb-2" role="alert">
          <p><strong>ATENÇÃO: </strong>O valor do frete para o comprador será calculado automaticamente com base nos
            CEP's de origem e destino e dimensões do produto com a embalagem previamente cadastrados na plataforma.</p>
        </div>

        <div class="row">
          <div class="col-xl-6">
            <app-campo [formulario]="adicionaLanceFormGroup" nomeControle="altura" autoPreenchimento="off"
              descricao="{{'altura_cm' | transloco}}" classe="horizontal-100"
              textoAjuda="{{'informar_metro' | transloco}}" mascara="separator.0"></app-campo>
          </div>
          <div class="col-xl-6">
            <app-campo [formulario]="adicionaLanceFormGroup" autoPreenchimento="off" nomeControle="largura"
              descricao="{{'largura_cm' | transloco}}" classe="horizontal-100"
              textoAjuda="{{'informar_metro' | transloco}}" mascara="separator.0"></app-campo>
          </div>
        </div>

        <div class="row pb-2">
          <div class="col-xl-6">
            <app-campo [formulario]="adicionaLanceFormGroup" autoPreenchimento="off" nomeControle="comprimento"
              descricao="{{'comprimento_cm' | transloco}}" classe="horizontal-100"
              textoAjuda="{{'informar_metro' | transloco}}" mascara="separator.0"></app-campo>
          </div>
          <div class="col-xl-6">
            <app-campo [formulario]="adicionaLanceFormGroup" autoPreenchimento="off" nomeControle="peso"
              descricao="{{'peso_gr' | transloco}}" classe="horizontal-100"
              textoAjuda="{{'informar_quilo' | transloco}}" mascara="separator.0"></app-campo>
          </div>
        </div>

        <div *ngIf="data.usado; then enviarImagem"></div>

        <ng-template #enviarImagem>

          <div class="row">
            <div class="col-xl-12">
              <input #uploadFileInput accept="image/png, image/gif, image/jpeg" type="file" class="upload-file-input"
                [multiple]="true" (change)="upload( uploadFileInput?.files)" />
            </div>

            <app-botao (clique)="uploadFileInput.click()" texto="&nbsp;Enviar imagens" classe="btn btn-link">

            </app-botao>
          </div>

          <div class="alert alert-primary pt-4 pb-1" role="alert">
            <p>Você pode adicionar as imagens do seu produto e elas serão exibidas em todo lance que você fizer nessa
              negociação.</p>
            <p>Para produtos <b>NOVOS</b> por padrão serão exibidas as imagens de nosso catálogo.</p>
          </div>

          <div class="row align-items-center pb-3">

            <div class="col-6 col-sm-3 imagem" *ngFor="let imagem of imagens">

              <a [href]="imagem" target="_blank">
                <img [src]="imagem">
              </a>
              <p>
                <app-botao icone="far fa-trash-alt" texto=" Remover " posicaoDoIcone="esquerda"
                  classe="btn-link text-danger" (clique)="excluirImagem(imagem)">
                </app-botao>
              </p>
            </div>
          </div>

        </ng-template>

        <div class="row">
          <div class="col-xl-6 order-sm-last">
            <app-botao texto="Incluir lance" [executando]="loading" classe="btn-primary horizontal-100"
              posicaoDoIcone="direita" (clique)="incluirLance()">
            </app-botao>
          </div>
          <div class="col-xl-6 order-sm-first">
            <app-botao texto="{{ 'cancelar' | transloco }}" [desabilitado]="loading"
              classe="btn-link text-uppercase horizontal-100" (clique)="dialogRef.close()">
            </app-botao>
          </div>
        </div>

      </mat-step>

      <mat-step>

        <h3><strong class="text-inversu pt-4">{{'tudo_certo' | transloco}}</strong></h3>
        <i class="fa-solid fa-mug-hot fa-10x text-inversu pt-4 pb-4"></i>
        <p>{{'aguardar_ofertas' | transloco}}</p>

        <div class="row">
          <div class="col-xl-6 order-xl-first">
            <app-botao texto="{{'ok_entendi' | transloco}} =)" [desabilitado]="loading"
              classe="btn-link text-uppercase horizontal-100" (clique)="dialogRef.close(lanceInserido)">
            </app-botao>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </div>

</form>